interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function YouTubeIcon(props: Props) {
  const { size = 17, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        clipRule="evenodd"
        d="M6.9 10.9V6.1l4.16 2.4-4.16 2.4Zm9.27-6.25a2 2 0 0 0-1.42-1.42C13.5 2.9 8.5 2.9 8.5 2.9s-5 0-6.25.33A2 2 0 0 0 .83 4.65C.5 5.9.5 8.5.5 8.5s0 2.6.33 3.85a2 2 0 0 0 1.42 1.42c1.25.33 6.25.33 6.25.33s5 0 6.25-.33a2 2 0 0 0 1.42-1.42c.33-1.25.33-3.85.33-3.85s0-2.6-.33-3.85Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
}
